import { logger } from '@fe/core';
import { useEffect } from 'react';
import { useAppDispatch } from '../../hooks/store-hooks';
import { startPlayback } from '../../state/reducers/playback';

export function PlaybackDragAndDrop() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const handleDragOver = (event: DragEvent) => {
            if (event.dataTransfer?.types.includes('Files')) {
                event.preventDefault();
            }
        };

        const handleDrop = (event: DragEvent) => {
            const items = event.dataTransfer?.items;
            if (!items || items.length !== 1 || items[0].kind !== 'file') {
                return;
            }

            event.preventDefault();
            const item = items[0];
            (async () => {
                try {
                    const handle = await item.getAsFileSystemHandle();
                    if (!handle || handle.kind !== 'file') {
                        return;
                    }
                    const fileHandle = handle as FileSystemFileHandle;
                    if (!fileHandle.name.toLowerCase().endsWith('.fwrx')) {
                        return;
                    }

                    let permission = await fileHandle.queryPermission({ mode: 'read' });
                    if (permission === 'prompt') {
                        permission = await fileHandle.requestPermission({ mode: 'read' });
                    }
                    if (permission !== 'granted') {
                        return;
                    }

                    await dispatch(
                        startPlayback({
                            kind: 'file',
                            file: fileHandle,
                            directory: null
                        })
                    ).unwrap();
                } catch (error) {
                    logger.trackException(error);
                }
            })();
        };

        window.addEventListener('dragover', handleDragOver);
        window.addEventListener('drop', handleDrop);

        return () => {
            window.removeEventListener('dragover', handleDragOver);
            window.removeEventListener('drop', handleDrop);
        };
    }, []);

    return null;
}
